import React from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { maximumEndcChartConfig } from '../chartConfigs';

/**
 * Props for the MaximumEndcEcharts component
 */
interface MaximumEndcEchartsProps {
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * Maximum ENDC Sessions Chart (LTE Site Level)
 * 
 * Displays EN-DC (E-UTRAN New Radio - Dual Connectivity) session capacity metrics:
 * - Maximum ENDC Users (count)
 * 
 * @component
 * @see {@link ../chartConfigs.ts} - Chart configuration (maximumEndcChartConfig)
 * @see API: /api/lte/maximum-endc?site_name={siteName}
 */

const MaximumEndcEcharts: React.FC<MaximumEndcEchartsProps> = ({ 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  return (
    <SiteCharts 
      config={maximumEndcChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
    />
  );
};

export default MaximumEndcEcharts;
